import { ChartingSelections } from "components/charting/types";
import { createContext } from "react";

const ChartSelectionsContext = createContext<ChartingSelections | undefined>(undefined);
ChartSelectionsContext.displayName = "ChartSelectionsContext";

export default ChartSelectionsContext;
